
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

import Modal from '@/components/layout/modal.vue';
import { ProfileActions } from '@/store/modules/user/profile/types';
import { RootActions, EventTypes } from '@/store/types';

export default Vue.extend({
  name: 'DeviceSecurityModalLayout',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('user/profile', ['showDeviceSecurityModal']),
  },
  methods: {
    ...mapActions('user/profile', {
      save: ProfileActions.SAVE_DEVICE_SECURITY_AGREE,
    }),
    ...mapActions([RootActions.DISPATCH_EVENT]),
    handleSave() {
      // Track the click event
      this[RootActions.DISPATCH_EVENT]({
        type: EventTypes.DEVICE_SECURITY_MODAL_CLICK,
        eventObj: {}
      });
      
      // Call the original save method
      this.save(true);
    },
  },
});
